<template lang="html">
  <v-content v-if="isLapTopCheck">
    <!-- this should be seperated, and data should depend on page-->
    <section>
      <v-layout row warp>
        <v-flex xs12>
          <v-layout column>
            <v-flex xs12 pt-0 mt-3>
              <div>
                <v-breadcrumbs large>
                  <v-icon slot="divider">forward</v-icon>
                  <v-breadcrumbs-item
                    v-for="item in item_bread_crumbs"
                    :key="item.text"
                    :disabled="item.disabled"
                    :href="item.name"
                  >
                  <v-icon v-if="item.text=='Home'" color="blue darken-2">home</v-icon>
                    {{ item.text }}
                  </v-breadcrumbs-item>
                </v-breadcrumbs>
              </div>
            </v-flex>
            <v-flex xs12 pt-0 mb-0>
              <v-divider pt-0 mb-0 class="my-3"></v-divider>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </section>

    <section>
      <v-container fluid grid-list-xl>
        <v-layout row justify-space-around>
          <!-- this should be seperated -->
          <v-flex xs3>
            <categories-card
              :popular_product="popular_product"
            ></categories-card>
          </v-flex>

          <!-- this should be seperated -->
          <v-flex xs9 mx-2>
            <v-layout column>
              <v-flex xs12>
                <v-container grid-list-xl>
                  <v-flex xs12>
                    <h2 style="font-size:36px">{{ header }}</h2>
                  </v-flex>
                  <v-layout row wrap align-center v-if="allData">
                    <v-flex xs12 v-if="allData.length == 0 || allData === undefined">
                      <v-container fill-height text-xs-center v-if="allData.length == 0 || allData === undefined">
                        <v-layout align-center justify-center>
                          <v-flex xs12 sm8 md4>
                            <div>
                              <v-progress-circular
                                :size="100"
                                :width="7"
                                indeterminate
                                color="primary"
                              ></v-progress-circular>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-flex>

                    <v-flex xs12 v-else>
                      <v-layout row wrap align-center>
                        <v-flex xs12 md4 v-for="(value,i) in getSliceData(allData)" :key="i">
                          <v-hover>
                            <v-card flat slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 1}`" class="mx-auto">
                              <div align="center">
                                <!-- i have to make "no product" image  -->
                                <v-img
                                  v-if="value.url === ''"
                                  :src="require('@/assets/no-product.png')"
                                  :lazy-src="require('@/assets/no-product.png')"
                                  aspect-ratio="1"
                                  max-height="200"
                                  contain
                                  class="white"
                                >
                                  <v-layout
                                    slot="placeholder"
                                    fill-height
                                    align-center
                                    justify-center
                                    ma-0
                                  >
                                    <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                                  </v-layout>
                                </v-img>
                                <v-img
                                  v-else
                                  :src="value.url"
                                  :lazy-src="value.url"
                                  aspect-ratio="1"
                                  max-height="200"
                                  contain
                                  class="white"
                                >
                                  <v-layout
                                    slot="placeholder"
                                    fill-height
                                    align-center
                                    justify-center
                                    ma-0
                                  >
                                    <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                                  </v-layout>
                                </v-img>
                              </div>
                              <v-card-title primary-title>
                                <div>
                                  <h3 style="font-size:16px">{{ value.name }}</h3>
                                  <div>
                                    <p>{{ value.code }}</p>
                                  </div>
                                  <div class="text-xs-center">
                                    <product-dialog
                                      :data="value"
                                      type="big"
                                    ></product-dialog>
                                  </div>
                                </div>
                              </v-card-title>
                            </v-card>
                          </v-hover>
                        </v-flex>
                        <v-flex xs12>
                          <div class="text-xs-center">
                            <v-pagination
                              v-model="page"
                              :length="pages"
                              @input="next"
                              :total-visible="3"
                            ></v-pagination>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                    <!-- need if else to check the data -->
                  </v-layout>
                  <v-layout row wrap align-center v-else>
                    <v-flex xs12>
                      <v-alert :value="true" color="error" icon="warning">
                        Sorry, nothing to display here :(
                      </v-alert>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>

            </v-layout>
          </v-flex>

        </v-layout>
      </v-container>
    </section>
  </v-content>

  <v-content v-else>
    <section>
      <v-layout column>
        <v-flex xs12 pt-0 mt-1>
          <div>
            <v-breadcrumbs>
              <v-icon slot="divider">forward</v-icon>
              <v-breadcrumbs-item
                v-for="item in item_bread_crumbs"
                :key="item.text"
                :disabled="item.disabled"
                :href="item.name"
              >
              <v-icon v-if="item.text=='Home'" color="blue darken-2">home</v-icon>
                {{ item.text }}
              </v-breadcrumbs-item>
            </v-breadcrumbs>
          </div>
        </v-flex>
        <v-flex xs12 pt-0 mb-3>
          <v-divider pt-0 mb-0 class="my-1"></v-divider>
        </v-flex>
      </v-layout>
    </section>

    <section>
      <div class="text-xs-center">
        <v-menu
        bottom
        origin="center center"
        transition="scale-transition"
      >
        <v-btn
          slot="activator"
          color="primary"
          dark
          round
        >
          หมวดหมู่/Categories
        </v-btn>

        <v-list>
          <v-list-tile
            v-for="(item, i) in items"
            :key="i"
            :to="{ name: item.name}"
          >
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      </div>
    </section>

    <section>
      <v-layout column>
        <v-flex xs12>

          <v-container grid-list-md>
            <v-flex xs12>
              <h2 style="font-size:35px">{{ header }}</h2>
            </v-flex>
            <v-layout row wrap align-center v-if="allData">
              <v-flex xs12 v-if="allData.length == 0 || allData === undefined">
                <v-container fill-height text-xs-center v-if="allData.length == 0 || allData === undefined">
                  <v-layout align-center justify-center>
                    <v-flex xs12 sm8 md4>
                      <div>
                        <v-progress-circular
                          :size="100"
                          :width="7"
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-flex>

              <v-flex xs12 v-else>
                <v-layout row wrap align-center>
                  <v-flex xs6 v-for="(value,i) in getSliceData(allData)" :key="i">
                    <v-hover>
                      <v-card flat slot-scope="{ hover }" :class="`elevation-${hover ? 12 : 1}`" class="mx-auto">
                        <div align="center">
                          <v-img
                            v-if="value.url === ''"
                            :src="require('@/assets/no-product.png')"
                            :lazy-src="require('@/assets/no-product.png')"
                            aspect-ratio="1"
                            max-height="100"
                            contain
                            class="white"
                          >
                            <v-layout
                              slot="placeholder"
                              fill-height
                              align-center
                              justify-center
                              ma-0
                            >
                              <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                            </v-layout>
                          </v-img>
                          <v-img
                            v-else
                            :src="value.url"
                            :lazy-src="value.url"
                            aspect-ratio="1"
                            max-height="100"
                            contain
                            class="white"
                          >
                            <v-layout
                              slot="placeholder"
                              fill-height
                              align-center
                              justify-center
                              ma-0
                            >
                              <v-progress-circular indeterminate color="blue darken-4"></v-progress-circular>
                            </v-layout>
                          </v-img>
                        </div>
                        <v-card-title primary-title>
                          <div>
                            <h3 style="font-size:14px">{{ value.name }}</h3>
                            <div>
                              <p>{{ value.code }}</p>
                            </div>
                            <div class="text-xs-center">
                              <product-dialog
                                :data="value"
                                type="big"
                              ></product-dialog>
                            </div>
                          </div>
                        </v-card-title>
                      </v-card>
                    </v-hover>
                  </v-flex>
                </v-layout>
                <v-flex xs12>
                  <div class="text-xs-center">
                    <v-pagination
                      v-model="page"
                      :length="pages"
                      @input="next"
                      :total-visible="3"
                    ></v-pagination>
                  </div>
                </v-flex>
              </v-flex>
            </v-layout>
            <v-layout row wrap align-center v-else>
              <v-flex xs12>
                <v-alert :value="true" color="error" icon="warning">
                  Sorry, nothing to display here :(
                </v-alert>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section>
  </v-content>
</template>

<script>
import ProductDialog from './productDialog.vue'
import CategoriesCard from './categoriesCard.vue'
export default {
  components: {
    ProductDialog,
    CategoriesCard
  },
  props: ['allData', 'popular_product', 'header', 'hearder_description', 'product_header', 'item_bread_crumbs', 'isLapTopCheck'],
  data: () => ({
    page: 1,
    checkDataSlice: false,
    items: [
      { title: 'สินค้าแนะนำ', name: 'popularProduct' },
      { title: 'เปลเด็ก & เตียงเด็ก', name: 'cradlesProduct' },
      { title: 'ชั้นวาง', name: 'shelvesProduct' },
      { title: 'โต๊ะ & เก้าอี้', name: 'tableSandSeatsProduct' },
      { title: 'ราว', name: 'racksProduct' },
      { title: 'ชั้นรองเท้า', name: 'beddingsProduct' },
      { title: 'ชั้นงานไม้', name: 'woodProduct' },
      { title: 'อื่นๆ', name: 'otherProduct' }
    ]
  }),
  computed: {
    pages () {
      var setPage = 1
      if (this.allData) {
        setPage = Math.ceil(this.allData.length / 12)
      }
      return setPage
    }
  },
  methods: {
    next () {
      this.getSliceData(this.allData)
      this.$vuetify.goTo(0)
    },
    getSliceData (data) {
      var dataSlice = {}
      if (data) {
        if (this.page) {
          var setDataFinal = this.page * 12
          var setDataBegin = setDataFinal - 12
          dataSlice = data.slice(setDataBegin, setDataFinal)
        } else {
          dataSlice = data
        }
      }
      return dataSlice
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/productModel.vue